import * as React           from 'react';
import RolesGrid from "../../components/bo-core/grids/RolesGrid/RolesGrid";

class Roles extends React.Component {
    render() {
        return (
            <div style={{backgroundColor: '#2B2B2B', height: '100%'}}>
                <RolesGrid/>
            </div>
        );
    }
}
export default Roles



// WEBPACK FOOTER //
// ./app/views/bo-core/Roles.tsx